
import React from 'react';
import { Activity } from 'lucide-react';

const WaterConsumptionKpi = () => {
  return (
    <div className="h-full flex items-center justify-center">
      <div className="p-4 flex flex-col items-center justify-center h-full w-full">
        <h3 className="text-lg font-medium text-gray-800 dark:text-white mb-2">Monthly Consumption</h3>
        <div className="mb-2">
          <Activity className="h-7 w-7 text-blue-500 mb-2" />
        </div>
        <p className="text-xl font-bold text-blue-500 mb-2">945 m³</p>
        <p className="text-xs text-green-400">↓ 1.8% from last month</p>
      </div>
    </div>
  );
};

export default WaterConsumptionKpi;
